export default {
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem',
  selectAll: 'Selecionar tudo',
  invert: 'Inverter'
}
